import styled from 'styled-components';
import { media } from '../../../constants/theme';

const { tablet, mobile, smallScreenLaptop, miniMobile } = media;

export const RandomProductsContents = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  max-width: 1600px;
  margin: 0 auto;
  grid-gap: 1rem;
  padding: 20px 15px;
  border-radius: 10px;
  background: white;
  .text-none {
    text-decoration: none;
  }

  ${smallScreenLaptop} {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  ${mobile} {
    grid-template-columns: auto auto;
  }

  ${miniMobile} {
    grid-gap: unset;
  }
`;

export const RandomProductsWrapper = styled.div`
  box-shadow: 4px 4px 30px rgba(35, 54, 79, 0.1);
  border-radius: 10px;
  width: calc(100% - 4rem);
  max-width: 1600px;
  background: white;
  margin: 15px auto;
  border-radius: 10px;
  #load-more {
    margin: 0 auto;
  }

  ${tablet} {
    margin: 2rem;

    .path-text {
      font-size: 0.6em;
    }
  }

  ${mobile} {
    margin: 2rem 0.5rem;
    width: calc(100% - 1rem);
    .hide-mobile {
      display: none;
    }
  }
`;
export const Header = styled.div`
  color: white;
  background: #ffa412;
  height: 60px;
  font-size: 18px;
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-bottom: 10px;
  p {
    font-weight: 500;
  }
  a {
    padding: 5px 10px;
    color: #fff;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
  }
  img {
    margin-left: 10px;
  }
  ${mobile} {
    font-size: 16px;
  }
`;
